import { CUSTOMER_MENU_ITEMS, CustomerService } from './../customer-service.service';
import { Location, CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { FormValidation } from 'src/app/services/FormValidation';
import Swal from 'sweetalert2';
import { ApiService } from 'src/app/services/api.service';
import { CustomValidator } from 'src/app/components/Helper/custom-validator';
import { BsModalService } from 'ngx-bootstrap/modal';
import { catchError, debounceTime, Observable, of, Subject, switchMap } from 'rxjs';
import { AppSettings } from 'src/app/services/AppSettings';
import { UtilService } from 'src/app/services/util.service';
import { BusinessProvider } from 'src/app/guard/business-details-guard.ts.service';
import { B2bDocumentSetupComponent } from 'src/app/components/shared/b2b-document-setup/b2b-document-setup.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-common-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, NgSelectModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './common-modal.component.html',
  styleUrls: ['./common-modal.component.scss']
})

export class CommonModalComponent extends FormValidation implements OnInit , OnChanges {
  businessId: any;
  businessEmail: any;
  selectedItem: CUSTOMER_MENU_ITEMS;
  contactFormIndividual!: FormGroup;
  contactFormBusiness!: FormGroup;
  networkDetailForm: FormGroup;
  B2bnetworkDetailForm: FormGroup;
  public FORMERROR = super.Form;
  submit: boolean = false
  errorMsg = false;
  @Input() b2bnetworkcarddata: { email: string, id: string };
  errorMsgTxt = "";
  private changeSubject = new Subject<{ type: 'email' | 'gigsumoNo', value: string }>();
  private currentType: 'email' | 'gigsumoNo';
  private B2BcurrentType: 'email' | 'organizationName' | 'platformBusinesId' | 'businessId';
  @Input('title') CONTENT: CUSTOMER_MENU_ITEMS;
  @Input('type') TYPE: "ADD" | "EDIT";
  @Input('data') DATA: any;
  @Input('ownerid') ownerId: any;
  @Input() businessDetails: any;
  @Input() bannerpassingvalues: any;
  @Input() openmodal: any;
  @Input() supplierBusinessId: string = '';
  @Input() customerBusinessId: string = '';
  @Input() customerBusinessName: string = '';
  b2bnetworkcardruote:any
  banneremail:any = null;
  peerContactType: string = null;
  peerSubContractAllowed: boolean = false;
  typeWarningMessage: string = null;
  // Accept flow only: when the initiator is Client/Supplier the receiver's Business Type
  // is force-mirrored to "Client/Supplier" (a single valid value), so show it read-only
  // instead of an editable dropdown. Stays false for all manual-choice flows.
  businessTypeLocked: boolean = false;
  @Output() updateNetworkList = new EventEmitter<{ value: any, action: string }>();
  @Output() response = new EventEmitter();
  @ViewChild('contactB2BModel', { static: true }) B2BContactModal: TemplateRef<any>;
  @ViewChild('contactModal', { static: true }) contactModal: TemplateRef<any>;
  private debounceSubject = new Subject<{ type: 'email' | 'organizationName' | 'platformBusinesId' | 'businessId', value: string }>();
  @ViewChild('networkModal', { static: true }) networkModal: TemplateRef<any>;
  @ViewChild('B2BnetworkModal', { static: true }) B2BnetworkModal: TemplateRef<any>;
  constructor(private API: ApiService, private fb: FormBuilder, private modalService: BsModalService,
    private activatedRoute: ActivatedRoute, private location: Location, private route: Router,
    private customerService: CustomerService, private util: UtilService,private businessProvider : BusinessProvider,
  ) {
    super()
    const data = this.location.path().split("?")[0];
    if (data) {
      this.selectedItem = data.split("/")[data.split("/").length - 1] as CUSTOMER_MENU_ITEMS;
    }

    // when user routes this will trigger
    this.route.events.subscribe(res => {
      if (res instanceof NavigationStart) {
        const data = res.url.split("?")[0];
        if (data) {
          this.selectedItem = data.split("/")[data.split("/").length - 1] as CUSTOMER_MENU_ITEMS;
        }
      }
    });



    this.activatedRoute.queryParamMap.subscribe(res => {
      this.b2bnetworkcardruote= res.get('b2bcardroute')
      this.businessId = res.get('id') ? res.get('id') : this.ownerId;
      this.businessEmail = res.get('businessEmail');
      this.banneremail = res.get('bannerbusinessEmail') ? res.get('bannerbusinessEmail') : res.get('businessEmail');

      const business = this.businessProvider.getBusiness();
      if(business != null){
        this.businessId = business.id;
        this.businessEmail = business.businessEmail;
        console.log("Business common modal " , business);
      }

    });


//fetching user details in contacts form by monisha

    this.changeSubject.pipe(
      debounceTime(1000),
      switchMap(({ type, value }) => {
        this.util.startLoader();
        if (type === 'email') {
          return this.API.create('user/findUser', { email: value });
        } else if (type === 'gigsumoNo' && value.length > 12) {
          return this.API.create('user/findUser', { gigsumoNo: value });
        }
        return [];
      })
    ).subscribe(
      res => this.handleResponse(res),
      error => {
        this.errorMsg = true;
        this.errorMsgTxt = "Failed to communicate with the server.";
      }
    );
    this.debounceSubject.pipe(
      debounceTime(100),
      switchMap(({ type, value }) => {
          this.util.startLoader();
          let payload: any = { limit: 20, pageNumber: 0, totalElements: 202 };


          if (type === 'email') {
              payload['businessEmail'] = value;
          } else if (type === 'organizationName') {
              payload['businessName'] = value;
          } else if (type === 'platformBusinesId') {
              payload['platformBusinesId'] = value;
          } else if (type === 'businessId') {
              payload['businessId'] = value;
          }

          return this.API.create('business/findbusiness', payload).pipe(

              catchError((error) => {
                  this.util.stopLoader();
                  this.errorMsgTxt = "Failed to communicate with the server.";
                  return of([]);
              })
          );
      })
  ).subscribe(
      (res: any) => {
          this.util.stopLoader();
          this.handleB2BResponse(res);
      },
      (error) => {
          this.util.stopLoader();
          this.errorMsgTxt = "Failed to communicate with the server.";
      }
  );


  }

  ngOnChanges(changes: SimpleChanges): void {
    // Update peerContactType when businessDetails arrives (may come after ngOnInit due to async parent)
    if (changes.businessDetails?.currentValue) {
      const details = changes.businessDetails.currentValue;
      if (details.peerContactType) {
        this.peerContactType = details.peerContactType;

        // Re-validate if user already selected a contact type before businessDetails arrived
        if (this.contactFormBusiness?.get('contactType')?.value) {
          this.onContactTypeChange(false);
        }
      }
      if (details.peerSubContractAllowed !== undefined) {
        this.peerSubContractAllowed = details.peerSubContractAllowed;
      }
    }
  }

  ngOnInit(): void {

    let modal = this.CONTENT === "businessContacts" ? this.B2BContactModal :
      this.CONTENT === "contacts" ? this.contactModal : this.CONTENT === "network" ? this.networkModal : this.B2BnetworkModal;
      const size = (this.CONTENT === "network" || this.CONTENT === "businessNetworks") ? "modal-md" : "modal-lg";

    if (this.CONTENT === "businessContacts") {
      this.addB2BContactForm();
      this.loadB2BNetworks();

      if (this.b2bnetworkcarddata?.id || this.bannerpassingvalues === 'ACCEPT') {
        this.peerContactType = this.businessDetails?.peerContactType || null;
        this.peerSubContractAllowed = this.businessDetails?.peerSubContractAllowed ?? false;
      }
    }

    if (this.CONTENT === "businessContacts" && this.supplierBusinessId) {
      // Auto-search by supplierBusinessId (from contract candidate 10002 flow)
      this.B2BcurrentType = 'businessId';
      this.businessTypes = ['Supplier', 'Client/Supplier'];
      this.enableFieldsBusiness(['b2bNetworks', 'contactType']);
      this.debounceSubject.next({ type: 'businessId', value: this.supplierBusinessId });
    }
    else if (this.CONTENT === "businessContacts" && this.customerBusinessId) {
      // Auto-search by customerBusinessId (supplier-side OFFER-ACCEPT 10002 flow:
      // the candidate's business is being invited to add the job owner as a Customer).
      // Restrict BusinessType to Client / Client/Supplier — the peer plays the customer role.
      this.B2BcurrentType = 'businessId';
      this.businessTypes = ['Client', 'Client/Supplier'];
      this.enableFieldsBusiness(['b2bNetworks', 'contactType']);
      this.debounceSubject.next({ type: 'businessId', value: this.customerBusinessId });
    }
    else if (this.CONTENT === "businessContacts" &&
      (this.banneremail !== undefined&&!this.openmodal ||
       (this.b2bnetworkcarddata && this.b2bnetworkcarddata.email !== undefined))) {
        this.emailBusIDSearch();
    }
    else if (this.CONTENT === "contacts") {

      if(this.TYPE === "EDIT"){
        this.DATA.organisation =  this.DATA.organisation !=null ? this.DATA.organisation : 'N/A',
        this.DATA.clientType = this.DATA.clientType!=null ? this.DATA.clientType :'N/A',
        this.DATA.phoneNo =  this.DATA.phoneNo != null ? this.DATA.phoneNo : 'N/A'
      }

      this.addUserForm(this.TYPE === 'EDIT' ? this.DATA : {
        email : null,
        firstName : null ,
        lastName : null,
        clientType : null,
        organisation : null,
        phoneNo : null,
        contactType : null,
        userType : null,
        gigsumoNo : null,
        userId : null,
        networkName : null,
        businessId : null
      });

      this.loadNetworks();
    }
    else if (this.CONTENT === "network") {
      this.addNetwork();
      this.networkDetailForm.patchValue(this.DATA);
    } else if (this.CONTENT === "businessNetworks") {
      this.addB2BNetwork();
    }

    if (modal) {
    this.modalService.show(modal, { backdrop: 'static', keyboard: false, class: size, ignoreBackdropClick: true });
    }

  }

  loadB2BNetworks() {
    let statusList = 'statusList';
    let data: any = {
      "businessId": this.businessId ? this.businessId : (this.ownerId ? this.ownerId : this.b2bnetworkcarddata.id),
      [statusList]: ["ACTIVE"],
      "limit":50
    };
    this.API.create('business/findB2BNetworks', data).subscribe(res => {
      // Keep the full list; the dropdown is filtered by the selected Business Type.
      this.allNetworks = res.data.b2bNetworks || [];
      const currentType = this.contactFormBusiness?.get('contactType')?.value;
      this.networks = currentType ? this.filterNetworksByType(currentType) : [];
      // Edit/Accept flows pre-select a type -> keep the dropdown enabled;
      // otherwise it stays disabled until a Business Type is chosen.
      const netCtrl = this.contactFormBusiness?.get('b2bNetworks');
      if (netCtrl) {
        currentType ? netCtrl.enable() : netCtrl.disable();
      }
      const netWork = this.TYPE === 'EDIT' ? this.DATA.networkName : null;
      if (netWork != null) {
        let data = netWork.split(',');
        // Resolve names against the full list so a saved network isn't dropped by the type filter.
        this.allNetworks.forEach((element, i) => {
          if (element.b2bNetworkName === data[i]) {
            data[i] = element.b2bNetworkId;
          }
        });
        this.contactFormBusiness.get('b2bNetworks').patchValue(data);
      }
    });
  }
  saveB2bnetwork() {
    this.B2bnetworkDetailForm.markAllAsTouched();
    if (this.B2bnetworkDetailForm.valid) {

      const params = {
        ...this.B2bnetworkDetailForm.value,
        networkOwnerId: this.businessId
      };
      this.util.startLoader();
      this.API.create('business/createB2BNetwork', params).subscribe(res => {
        this.util.stopLoader();
        if (res.code === AppSettings.SUCESS_CODE) {
          this.closeModal(true);
        }else if(res.code=="99998"){
          this.B2bnetworkDetailForm.get('b2bNetworkName').setErrors({exists : true});
          this.errorMsgTxt = "Network already exists";
        }
      });
    }
  }

  addNetwork() {
    this.networkDetailForm = this.fb.group({
      businessNetworkName: [null, [Validators.required, CustomValidator.teamminmaxLetters(this.NETWORK_NAME.min, this.NETWORK_NAME.max)]],

    })
  }
  addB2BNetwork() {
    this.B2bnetworkDetailForm = this.fb.group({
      b2bNetworkName: [null, [Validators.required, CustomValidator.teamminmaxLetters(this.NETWORK_NAME.min, this.NETWORK_NAME.max)]],
      type: ['', [Validators.required]] // Correctly initialize with an empty string
    });
  }




  organizationTypes = ['Staffing Agency', 'Consulting Firm', 'Other'];
  contactTypes = ['Supplier', 'Client'];
  businessTypes = ['Client', 'Supplier', 'Client/Supplier'];
  roles = ['Recruiter', 'Manager', 'HR'];
  networks: any = [];
  allNetworks: any[] = [];
  statuses = ['Active', 'Inactive'];

  addUserForm(data) {

    this.contactFormIndividual = this.fb.group({
      firstName: [data.firstName],
      lastName: [data.lastName],
      businessId: [''],
      organizationName: [data.organisation],
      organizationType: [data.clientType],
      email:[data.email, [Validators.email, Validators.required, CustomValidator.max(this.EMAIL.max),
        Validators.pattern(this.EMAIL.pattern)]],
      phone: [data.phoneNo],
      contactType: [data.contactType, Validators.required],
      role: [this.getUserRole(data.userType)],
      gigsumoNo: [data.gigsumoNo, [Validators.required, CustomValidator.max(this.MAX_GIGSUMONO.max),Validators.pattern('^[a-zA-Z0-9]*$')]],
      userId: [data.userId],
      businessNetworks: [null, Validators.required],
    });

    if (this.TYPE == "EDIT") {
      this.enablekeys = ['businessNetworks', 'contactType'];
    }

    this.enableFields(this.enablekeys)

  }


  options: { organizationId: string, organizationName: string }[] = [];

  filteredOptions: Observable<any[]>;
  addB2BContactForm() {
    this.contactFormBusiness = this.fb.group({
      organizationName: [null, [Validators.required, CustomValidator.max(this.ORGNAME.max),
      ]],
      platformBusinesId: [
        '',
        [
          Validators.required,
          CustomValidator.max(this.PLATFORM_BUSINESSID.max),
          Validators.pattern('^[a-zA-Z0-9]*$')
        ]
      ],
      email: [null, [Validators.email, Validators.required, CustomValidator.max(this.EMAIL.max),
      Validators.pattern(this.EMAIL.pattern)]],
      phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      contactType: [null, Validators.required],
      role: ['', Validators.required],
      firstName: ['', Validators.required],
      b2bNetworks: ['', Validators.required],
      organizationType: ['', Validators.required],
      lastName: ['', Validators.required],
      businessId: ['', Validators.required],
      peerBusinessId: ['', Validators.required],
      subContractAllowed: [true],
    });

    this.FormInputlistning();
    if (this.ownerId||this.b2bnetworkcarddata&&this.b2bnetworkcarddata.id) {
      this.enablekeyBusiness = ['b2bNetworks','contactType'];
    }
      this.enableFieldsBusiness(this.enablekeyBusiness);

  }
  onContactTypeChange(userInitiated: boolean = true): void {
    const contactType = this.contactFormBusiness.get('contactType')?.value;

    // Filter the network dropdown by the chosen Business Type and enable it.
    // On a user-driven change we clear any previously selected networks (they may
    // belong to the old type); on a programmatic re-validate we keep the selection.
    this.applyNetworkFilterForType(userInitiated);

    // Reciprocal type validation (accept flow only)
    // Skip validation for the mutual types (Client/Supplier, legacy Customer/Supplier)
    // since they already cover both the Client and Supplier roles.
    if (this.peerContactType && contactType && contactType !== 'N/A'
        && contactType !== 'Customer/Supplier' && contactType !== 'Client/Supplier'
        && contactType === this.peerContactType) {
      const reciprocal = contactType === 'Client' ? 'Supplier' : 'Client';
      this.typeWarningMessage = `This contact is already classified as "${contactType}". Please select "${reciprocal}", or create a separate connection profile for a ${contactType} relationship.`;
      this.contactFormBusiness.get('contactType')?.setErrors({ reciprocalType: true });
    } else {
      this.typeWarningMessage = null;
      if (this.contactFormBusiness.get('contactType')?.hasError('reciprocalType')) {
        this.contactFormBusiness.get('contactType')?.setErrors(null);
      }
    }

    // subContractAllowed logic — show for Supplier or Customer/Supplier
    if (contactType === 'Supplier' || contactType === 'Customer/Supplier') {
      this.contactFormBusiness.get('subContractAllowed')?.setValue(true);
    } else {
      this.contactFormBusiness.get('subContractAllowed')?.setValue(null);
    }
  }

  // Business Type -> allowed network types.
  //  Client            -> Client networks
  //  Supplier          -> Supplier networks
  //  Client/Supplier   -> General (N/A) + Client/Supplier networks
  //  N/A / other       -> handled separately, no filtering applied here
  private normalizeBusinessType(t: string): string {
    return t === 'Customer/Supplier' ? 'Client/Supplier' : t;
  }

  filterNetworksByType(businessType: string): any[] {
    const all = this.allNetworks || [];
    const bt = this.normalizeBusinessType(businessType);
    if (bt === 'Client') {
      return all.filter(n => n.type === 'Client');
    }
    if (bt === 'Supplier') {
      return all.filter(n => n.type === 'Supplier');
    }
    if (bt === 'Client/Supplier') {
      // backend canonical network type is 'Client_Supplier'; 'N/A' + slash kept for legacy rows
      return all.filter(n => n.type === 'N/A' || n.type === 'Client_Supplier' || n.type === 'Client/Supplier');
    }
    return all;
  }

  private applyNetworkFilterForType(clearSelection: boolean): void {
    const type = this.contactFormBusiness?.get('contactType')?.value;
    const netCtrl = this.contactFormBusiness?.get('b2bNetworks');
    if (!type) {
      this.networks = [];
      if (netCtrl) { netCtrl.reset(); netCtrl.disable(); }
      return;
    }
    this.networks = this.filterNetworksByType(type);
    if (clearSelection && netCtrl) {
      netCtrl.setValue(null);
    }
    if (netCtrl && netCtrl.disabled) {
      netCtrl.enable();
    }
  }

  restrictSpecialChars(event: KeyboardEvent) {
    const pattern = /[a-zA-Z0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  FormInputlistning(){
    Object.keys(this.contactFormBusiness.controls).forEach(controlName => {
      this.contactFormBusiness.get(controlName).valueChanges.subscribe(() => {
        this.contactFormBusiness.get(controlName).updateValueAndValidity({ onlySelf: true, emitEvent: false });
      });
    });
  }

  handleInvite(action: 'ACCEPT') {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success' },
      buttonsStyling: false
    })
    let contactStatus: string;
    let successMessage: string;
    const formData = this.contactFormBusiness.getRawValue();
    contactStatus = "CONNECTED";
    successMessage = "Request accepted successfully";
    // Map requestType: what I am TO the contact
    const ct = formData.contactType;
    let requestType = null;
    if (ct === 'Supplier') {
      requestType = 'CUSTOMER';
    } else if (ct === 'Client') {
      requestType = 'SUPPLIER';
    } else if (ct === 'Customer/Supplier') {
      requestType = 'Customer/Supplier';
    }

    const data = {
        businessId: this.b2bnetworkcarddata&&this.b2bnetworkcarddata.id?this.b2bnetworkcarddata.id:this.ownerId,
        ...formData,
        contactStatus: contactStatus,
        peerB2bNetworks: formData.b2bNetworks,
        peerContactType: formData.contactType,
        requestType: requestType,
        // Accept side: map subContractAllowed → peerSubContractAllowed
        peerSubContractAllowed: formData.subContractAllowed,
    };
    delete data.b2bNetworks;
    delete data.contactType;
    delete data.subContractAllowed;
    this.util.startLoader();
    this.API.create("business/updateB2BContact", data).subscribe(
        (res) => {
            this.util.stopLoader();
            if (res.code == "00000") {

                Swal.fire({
                    icon: "success",
                    title: successMessage,
                    showConfirmButton: false,
                    timer: 2000,
                }).then(() => {
                  this.modalService.hide(this.modalService.getModalsCount());
                    this.updateNetworkList.emit({ value: null, action: 'accept' });
                    const assignEmployeesSwal = () => {
                      swalWithBootstrapButtons.fire({
                          title: 'Assign Business Employees',
                          text: 'Now that you have connected to the business contact. Please, map your employees that you want to work with this business.',
                          icon: 'question',
                          confirmButtonText: 'OK',
                          allowOutsideClick: false,
                          allowEscapeKey: false,
                          reverseButtons: true,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          const queryParams = {
                              ...this.businessDetails,
                              contactBusinessId: this.businessDetails.contactBusinessId
                          };
                          this.route.navigate(['/user-management/businessContacts/businessConnectEdit'], {
                              queryParams: queryParams
                          });
                        }
                      });
                    };
                    const mode = formData.contactType === 'Supplier' ? 'customer' : 'supplier';
                    if (mode === 'customer') {
                      const myBizId = data.businessId;
                      const peerBizId = formData.peerBusinessId;
                      this.API.query(`business/getB2BContact/${myBizId}/${peerBizId}`)
                        .subscribe((b2bRes: any) => {
                          const b2bContactId = b2bRes?.data?.b2bContact?.b2bContactId;
                          if (b2bContactId) {
                            this.modalService.show(B2bDocumentSetupComponent, {
                              initialState: {
                                b2bContactId,
                                myBusinessId: myBizId,
                                peerBusinessId: peerBizId,
                                peerBusinessName: this.businessDetails?.businessName || this.businessDetails?.organizationName,
                                mode: 'customer'
                              },
                              class: 'modal-lg',
                              backdrop: 'static',
                              keyboard: false
                            });
                            const onHiddenSub = this.modalService.onHidden.subscribe(() => {
                              onHiddenSub.unsubscribe();
                              assignEmployeesSwal();
                            });
                          } else {
                            assignEmployeesSwal();
                          }
                        });
                    } else {
                      assignEmployeesSwal();
                    }
                });
            } else {
                Swal.fire({
                    icon: "info",
                    title: "Oops...",
                    text: action === 'ACCEPT'
                        ? "Connection accept request failed. Please try after a while."
                        : action === 'REJECT'
                        ? "Connection reject request failed. Please try after a while."
                        : "Something went wrong. Please try after some time.",
                    showConfirmButton: false,
                    timer: 4000,
                });
            }
        },
        (error) => {
            // Handle error case
            this.util.stopLoader();
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong. Please try again later.",
                showConfirmButton: false,
                timer: 4000,
            });
        }
    );
}

//  contact form submit function by monisha
  onSubmit(): void {
    const currentKey = this.currentType === "email" ? 'email' : 'gigsumoNo';
    this.contactFormIndividual.markAllAsTouched();
    if (this.contactFormIndividual.valid) {
      if (this.businessEmail == this.contactFormIndividual.getRawValue().email) {
        Swal.fire({
          icon: 'info',
          title: 'Emails Match',
          text: 'The business email and the email in the contact form are the same. Please provide a different contact email.',
        });
        return;
      }
      let formData = this.contactFormIndividual.getRawValue();
      formData.phone = formData.phone === 'N/A' ? null : formData.phone;
      formData.businessId = this.businessId;
      this.util.startLoader();

      const API = this.TYPE == "ADD" ? this.API.create('business/createBusinessUsersContact', formData) :
        this.API.updatePut('business/editBusinessUsersContact', formData);

      API.subscribe(res => {
        this.util.stopLoader();
        if (res.code === AppSettings.SUCESS_CODE) {
          this.closeModal(true);
        } else if (res.code == "99998") {
          this.contactFormIndividual.get(currentKey).setErrors({ emailError: true });
          this.errorMsgTxt = "Contact already exists";
        }
      });

    }
  }

//  buiness form submit function by monisha
  onSubmitBusiness(): void {
    if((this.b2bnetworkcarddata&&this.b2bnetworkcarddata.id||this.bannerpassingvalues=='ACCEPT')&&this.contactFormBusiness.valid){
       this.handleInvite('ACCEPT');
    }else{
      const currentKey = this.B2BcurrentType === "email"
      ? 'email'
      : this.B2BcurrentType === "platformBusinesId"
      ? 'platformBusinesId'
      : 'organizationName';
      this.contactFormBusiness.markAllAsTouched();
      if (this.contactFormBusiness.valid) {
        if (this.businessEmail == this.contactFormBusiness.getRawValue().email &&!this.b2bnetworkcardruote) {
          Swal.fire({
            icon: 'info',
            title: 'Emails Match',
            text: 'The business email and the email in the contact form are the same. Please provide a different contact email.',
          });
          return;
        }
        let formData = this.contactFormBusiness.getRawValue();

        // Map requestType: what I am TO the contact. The mutual type (Client/Supplier) is
        // symmetric, so requestType mirrors the chosen Business Type instead of inverting.
        const ct = formData.contactType;
        if (ct === 'Supplier') {
          formData.requestType = 'CUSTOMER';
        } else if (ct === 'Client') {
          formData.requestType = 'SUPPLIER';
        } else if (ct === 'Customer/Supplier' || ct === 'Client/Supplier') {
          formData.requestType = ct;
        } else {
          formData.requestType = null;
        }

        this.util.startLoader();
        this.API.create("business/createB2BContact", formData).subscribe(res => {
          this.util.stopLoader();
          if (res.code === AppSettings.SUCESS_CODE) {
            this.updateNetworkList.emit({ value: null, action: 'create' });

            // Capture values before closeModal resets state
            const myBizId = formData.businessId;
            const peerBizId = formData.peerBusinessId;
            const peerBizName = formData.organizationName;
            const contactType = formData.contactType;

            this.closeModal(true);

            // Show document setup modal if adding peer as Supplier (I am Customer)
            if (contactType === 'Supplier') {
              setTimeout(() => {
                this.API.query(`business/getB2BContact/${myBizId}/${peerBizId}`)
                  .subscribe((b2bRes: any) => {
                    const b2bContactId = b2bRes?.data?.b2bContact?.b2bContactId;
                    if (b2bContactId) {
                      this.modalService.show(B2bDocumentSetupComponent, {
                        initialState: {
                          b2bContactId,
                          myBusinessId: myBizId,
                          peerBusinessId: peerBizId,
                          peerBusinessName: peerBizName,
                          mode: 'customer'
                        },
                        class: 'modal-lg',
                        backdrop: 'static',
                        keyboard: false
                      });
                    }
                  });
              }, 500);
            }
          } else if (res.code == "99998") {
            this.contactFormBusiness.get(currentKey).setErrors({ b2berror: true });
            this.errorMsgTxt = "Contact already exists";
          }
        });

      }
    }

  }
//  buiness form enable disable function by monisha
  enablekeyBusiness = ['email', 'platformBusinesId', 'organizationName', 'b2bNetworks','contactType'];
  enableFieldsBusiness(keys: string[]) {
    // Network dropdown is only usable once a Business Type is selected — without a
    // type we cannot decide which networks are valid to add this business to.
    const hasBusinessType = !!this.contactFormBusiness.get('contactType')?.value;
    Object.keys(this.contactFormBusiness.controls).forEach((controlKey) => {
      if (controlKey === 'subContractAllowed') {
        this.contactFormBusiness.get(controlKey).enable();
        return;
      }
      if (controlKey === 'b2bNetworks') {
        if (keys.includes(controlKey) && hasBusinessType) {
          this.contactFormBusiness.get(controlKey).enable();
        } else {
          this.contactFormBusiness.get(controlKey).disable();
        }
        return;
      }
      if (keys.includes(controlKey)) {
        this.contactFormBusiness.get(controlKey).enable();
      } else {
        this.contactFormBusiness.get(controlKey).disable();
      }
    });
  }
//  contacs form enable disable function by monisha
  enablekeys = ['email', 'gigsumoNo', 'businessNetworks', 'contactType']

  enableFields(keys: string[]) {
    Object.keys(this.contactFormIndividual.controls).forEach((controlKey) => {
      if (keys.includes(controlKey)) {
        this.contactFormIndividual.get(controlKey).enable();
      } else {
        this.contactFormIndividual.get(controlKey).disable();
      }
    });
  }
  countryAPIresponse = [];
  getCountry() {
    this.API.query('country/getAllCountries').subscribe(data => {
      this.countryAPIresponse = data;
    })
  }
  getUserRole(userType: string): string {
    const rolesMapping = {
      MANAGEMENT_TALENT_ACQUISITION: 'Manager',
      RECRUITER: 'Recruiter',
      BENCH_RECRUITER: 'Bench Recruiter',
      JOB_SEEKER: 'Job Seeker',
      FREELANCE_RECRUITER: 'Freelancer Recruiter'
    };
    const normalizedUserType = userType && userType.replace(/ /g, "_").toUpperCase();
    return rolesMapping[normalizedUserType] || 'Unknown Role';
  }



  pathchvalues(option){
    const myBusinessId = this.businessId
      ? this.businessId
      : (this.ownerId
          ? this.ownerId
          : (this.b2bnetworkcarddata ? this.b2bnetworkcarddata.id : ''));

    this.contactFormBusiness.patchValue({
      email: option.businessEmail,
      organizationName: option.businessName,
      platformBusinesId: option.platformBusinesId,
      businessId: myBusinessId,
      peerBusinessId: option.businessId,
      b2bNetworks: option.b2bNetworks,
      peerB2bNetworks: this.b2bnetworkcarddata && this.b2bnetworkcarddata.id ?option.b2bNetworks:'',
      organizationType: option.organizationType,
      firstName: option.adminUserData?.firstName || '',
      lastName: option.adminUserData?.lastName || '',
      role: this.getUserRole(option.adminUserData?.userType || ''),
      phone: option.adminUserData?.phone ? option.adminUserData.phone : 'N/A',
    });

    // Fetch B2B contact to patch subContractAllowed
    if (myBusinessId && option.businessId) {
      this.loadB2BContact(myBusinessId, option.businessId);
    }
  }

  loadB2BContact(businessId: string, peerBusinessId: string) {
    this.API.query(`business/getB2BContact/${businessId}/${peerBusinessId}`)
      .subscribe(response => {
        if (response?.code === AppSettings.SUCESS_CODE && response.data?.b2bContact) {
          const b2bContact = response.data.b2bContact;

          // CREATE flow (not accept/edit): a connection that already exists and is NOT
          // CANCELLED/REJECTED means this business is already connected. Mirror the backend
          // duplicate rule (requestB2BContact) and surface it here instead of letting the
          // user fill the form and only fail on submit.
          const isCreateFlow = !(this.b2bnetworkcarddata && this.b2bnetworkcarddata.id)
            && this.bannerpassingvalues !== 'ACCEPT';
          const status = (b2bContact.contactStatus || '').toString().toUpperCase();
          const reusable = status === 'CANCELLED' || status === 'REJECTED';
          if (isCreateFlow && !reusable) {
            const field = this.B2BcurrentType || 'organizationName';
            this.contactFormBusiness.get(field)?.setErrors({ b2berror: true });
            this.errorMsgTxt = 'Contact already exists';
            return;
          }

          const subContract = b2bContact.subContractAllowed ?? false;
          this.contactFormBusiness.get('subContractAllowed')?.setValue(subContract);

          // Filter businessTypes based on peer's contactType
          const contactType = b2bContact.contactType;
          if (contactType === 'Client') {
            this.businessTypes = ['Supplier', 'Client/Supplier'];
          } else if (contactType === 'Supplier') {
            this.businessTypes = ['Client', 'Client/Supplier'];
          } else {
            this.businessTypes = ['Client', 'Supplier', 'Client/Supplier'];
          }

          // The read-only "Organization Type" field must reflect the INITIATOR's Business Type
          // (b2bContact.contactType). pathchvalues() seeds it from option.organizationType, which
          // can be stale/wrong (e.g. "Client" for a Client/Supplier request) — override it with the
          // authoritative contact value here. Client_Supplier is displayed as "Client/Supplier".
          if (contactType) {
            const initiatorBusinessType =
              (contactType === 'Client_Supplier' || contactType === 'Customer/Supplier')
                ? 'Client/Supplier'
                : contactType;
            this.contactFormBusiness.get('organizationType')?.setValue(initiatorBusinessType);
          }

          // Accept flow: when the initiator chose Client/Supplier, the connection is mutual, so the
          // receiver's Business Type must mirror it — auto-select "Client/Supplier" instead of leaving
          // the required dropdown empty. Plain Client / Supplier requests stay a manual choice.
          const isAcceptFlow = !!this.b2bnetworkcarddata?.id || this.bannerpassingvalues === 'ACCEPT';
          if (isAcceptFlow && (contactType === 'Client_Supplier'
              || contactType === 'Client/Supplier' || contactType === 'Customer/Supplier')) {
            const typeCtrl = this.contactFormBusiness.get('contactType');
            typeCtrl?.setValue('Client/Supplier');
            // Single valid value -> render read-only (no dropdown).
            this.businessTypeLocked = true;
            // Re-run the change handler (non-user-initiated) to filter/enable the network dropdown
            // and clear any stale reciprocal error for the pre-selected mutual type.
            this.onContactTypeChange(false);
          }
        }
      });
  }


  APIResponse=[];
  handleB2BResponse(res: any) {
    this.util.stopLoader();
    if (res?.data?.businessUsersList?.length === 0) {
         this.errorMsgTxt = "Business not found!";
      const currentValues = this.contactFormBusiness.value;
      const resetValues = {};
      Object.keys(currentValues).forEach(key => {
        resetValues[key] = key === this.B2BcurrentType ? currentValues[key] : null;
      });
      this.contactFormBusiness.reset(resetValues);
      this.contactFormBusiness.get(this.B2BcurrentType)?.setErrors({ b2berror: true });
    }
   //plan validation in business form by monisha
    else {
      const subscriptionType = res?.data?.businessUsersList[0].subscriptionType;
      if (["Free"].includes(subscriptionType)&&this.B2BcurrentType !== 'organizationName') {
        this.contactFormBusiness.get(this.B2BcurrentType)?.setErrors({ b2berror: true });
        this.errorMsgTxt = "The owner is not on the Starter Growth and ScaleX Plan!";
      } else {
        if (this.B2BcurrentType !== 'organizationName') {
          let option = res.data.businessUsersList[0];
          this.pathchvalues(option);
        } else {
          this.APIResponse = res.data.businessUsersList;
        }
        this.errorMsgTxt = '';
      }

    }
  }

  emailBusIDSearch() {
    if ((this.banneremail && !this.openmodal) || (this.b2bnetworkcarddata && this.b2bnetworkcarddata.email)) {
      this.B2BcurrentType = 'email';
      this.errorMsgTxt = '';

      const emailValue = this.banneremail && !this.openmodal
                          ? this.banneremail.trim()
                          : this.b2bnetworkcarddata.email;

      this.debounceSubject.next({ type: 'email', value: emailValue });
    }
    else{
      const emailControl = this.contactFormBusiness.get('email');
      const emailValue = emailControl?.value;
          if (!emailValue) {
            this.enableFieldsBusiness(['email', 'b2bNetworks','platformBusinesId','organizationName','contactType']);
              this.clearAllBusinessFields();
               this.errorMsgTxt = '';
              return;
          }
      if (emailControl?.valid) {
          this.B2BcurrentType = 'email';
          this.errorMsgTxt = '';
          this.enableFieldsBusiness(['email', 'b2bNetworks','contactType']);
          this.debounceSubject.next({ type: 'email', value: emailValue.trim() });
      } else {
        this.errorMsgTxt = '';
        this.resetFieldsExcept(this.contactFormBusiness, ['email']);
        this.enableFieldsBusiness(['email', 'b2bNetworks','contactType']);

      }
    }
}




BusIDSearch() {
  const businessIdcontrol = this.contactFormBusiness.get('platformBusinesId');
  if (businessIdcontrol) {
    let b2bid = businessIdcontrol.value;
    b2bid = b2bid.replace(/[^a-zA-Z0-9]/g, '');
    businessIdcontrol.setValue(b2bid, { emitEvent: false });

    if (!b2bid) {
      this.errorMsgTxt = '';
      this.enableFieldsBusiness(['email', 'b2bNetworks','platformBusinesId','organizationName','contactType']);
      this.clearAllBusinessFields();
      this.contactFormBusiness.markAllAsTouched();
      return;
    }
    if (businessIdcontrol.valid && b2bid.length >= 13  ) {
      this.B2BcurrentType = 'platformBusinesId';
      this.enableFieldsBusiness(['platformBusinesId', 'b2bNetworks','contactType']);
      this.contactFormBusiness.get('platformBusinesId').setErrors(null);
      this.errorMsgTxt = '';
      this.debounceSubject.next({ type: 'platformBusinesId', value: b2bid.trim() });
    } else if (b2bid.length < 13) {
      this.contactFormBusiness.get('platformBusinesId').setErrors({ b2berror: true });
      this.errorMsgTxt = "Invalid gigsumo BID";
      this.resetFieldsExcept(this.contactFormBusiness, ['platformBusinesId', 'b2bNetworks','contactType']);
    } else {
      this.errorMsgTxt = '';
      this.resetFieldsExcept(this.contactFormBusiness, ['platformBusinesId']);
      this.enableFieldsBusiness(['platformBusinesId', 'b2bNetworks','contactType']);
      this.errorMsgTxt = '';
    }
  }
}

OrganizationSearch() {
  const organizationControl = this.contactFormBusiness.get('organizationName');
  if (organizationControl ) {
    const organizationName = organizationControl.value;
    if (!organizationName) {
      this.errorMsgTxt = '';
      this.enableFieldsBusiness(['email', 'b2bNetworks','platformBusinesId','organizationName','contactType']);
      this.clearAllBusinessFields();
      return;
    }
    if (organizationControl.valid && organizationName.length > 2) {

      this.B2BcurrentType = 'organizationName';
      this.enableFieldsBusiness(['organizationName', 'b2bNetworks','contactType']);
      this.contactFormBusiness.get('organizationName').setErrors(null);
      this.errorMsgTxt = '';
      this.debounceSubject.next({ type: 'organizationName', value: organizationName });
    } else if (organizationName.length < 2) {
      this.contactFormBusiness.get('organizationName').setErrors({ b2berror: true });
      this.errorMsgTxt = "Business not found!";
      this.resetFieldsExcept(this.contactFormBusiness, ['organizationName', 'b2bNetworks','contactType']);
    } else {
      this.errorMsgTxt = '';
      this.resetFieldsExcept(this.contactFormBusiness, ['organizationName']);
      this.enableFieldsBusiness(['organizationName', 'b2bNetworks','contactType']);
      this.errorMsgTxt = '';
    }
  }
}
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.suggestions-list') && !target.closest('#organizationName')) {
      this.APIResponse = [];
    }
  }


  onSelect(option: any) {
    this.APIResponse = [];
    const organizationControl = this.contactFormBusiness.get('organizationName');

    if (["Free"].includes(option.subscriptionType)) {
      organizationControl?.patchValue(option.businessName);
      organizationControl?.setErrors({ b2berror: true });
      this.errorMsgTxt = "The owner is not on the Starter (or) Growth or ScaleX plan!";
    } else {
      this.errorMsgTxt = '';
      this.pathchvalues(option);
      this.enableFieldsBusiness(['organizationName', 'b2bNetworks', 'contactType']);
    }
  }


  onEmailChange() {
    const emailControl = this.contactFormIndividual.get('email');
    if (emailControl) {
      const email = emailControl.value;

      if (!email ) {
        let key: any = ['email','gigsumoNo', 'contactType', 'businessNetworks'];
        this.enableFields(key);
        this.clearAllFields();
        this.errorMsgTxt = '';
        return;
      }

      if (emailControl.valid) {
        this.currentType = 'email';
        this.changeSubject.next({ type: 'email', value: email.trim() });
      } else {
        let key: any = ['email', 'contactType', 'businessNetworks'];
        this.enableFields(key)
      }
    }
  }
//reset function in contact form by monisha
  clearAllFields() {
    Object.keys(this.contactFormIndividual.controls).forEach((controlKey) => {
      const control = this.contactFormIndividual.get(controlKey);
      if (control) {
        control.reset();

      }
    });
  }


  handleResponse(res) {
    const currentKey = this.currentType === "email" ? 'email' : 'gigsumoNo';
    this.util.stopLoader();

    if (res?.code === AppSettings.SUCESS_CODE && res.data?.userData) {
      const { userData } = res.data;
      const isUserActive = userData.userStatus === 'ACTIVE';

      if (!isUserActive) {
        this.setError(currentKey, "User is inactive");
      } else {
        this.updateForm(userData);
        this.enableFields([currentKey, 'businessNetworks', 'contactType']);
      }
    } else if (res?.code === "99998") {
      this.enableFields([currentKey, 'businessNetworks', 'contactType']);
      this.resetFieldsExcept(this.contactFormIndividual, [currentKey]);
      this.setError(currentKey, "User not found!");
    }
  }

  setError(key: string, message: string) {
    this.contactFormIndividual.get(key).setErrors({ emailError: true });
    this.errorMsgTxt = message;
  }

//onchnage function in gigsumoid by monisha
  onGigsumoidChange() {
    const gigsumoidControl = this.contactFormIndividual.get('gigsumoNo');
    if (gigsumoidControl) {
      let gigsumoNo = gigsumoidControl.value;
      gigsumoNo = gigsumoNo.replace(/[^a-zA-Z0-9]/g, '');
      gigsumoidControl.setValue(gigsumoNo, { emitEvent: false });
      if (!gigsumoNo) {
        this.errorMsgTxt = '';
        let key: any = ['email','gigsumoNo', 'contactType', 'businessNetworks'];
        this.enableFields(key);
        this.resetFieldsExcept(this.contactFormIndividual, ['gigsumoNo']);
        return;
      }
      if (gigsumoidControl.valid && gigsumoNo.length === 13) {
        this.currentType = 'gigsumoNo';
        this.changeSubject.next({ type: 'gigsumoNo', value: gigsumoNo.trim() });
        this.contactFormIndividual.get('gigsumoNo').setErrors({ pattern: true });
        this.errorMsgTxt = '';
      } else if (gigsumoNo.length < 13) {
        this.contactFormIndividual.get('gigsumoNo').setErrors({ emailError: true });
        this.errorMsgTxt = "Invalid gigsumo no";
        this.resetFieldsExcept(this.contactFormIndividual, ['gigsumoNo']);
      } else {
        let key: any = ['gigsumoNo', 'contactType', 'businessNetworks'];
        this.enableFields(key);
        this.errorMsgTxt = '';
      }
    }
  }

  clearAllBusinessFields() {
    Object.keys(this.contactFormBusiness.controls).forEach((controlKey) => {
      const control = this.contactFormBusiness.get(controlKey);
      if (control) {
        control.reset();
       }
    });
  }
  updateForm(userData: any) {
    let response = userData;
    console.log("role " , userData);

      let values: any = {
        peerBusinessId: response.businessId,
        businessId: this.businessId,
        organizationName: response.workExperience[0] && response.workExperience[0].organisationName!=null?response.workExperience[0].organisationName:'N/A',
        email: response.username,
        organizationType: response.clientType!=null?response.clientType:'N/A',
        firstName: response.firstName,
        lastName: response.lastName,
        gigsumoNo: response.gigsumoNo,
        userId: response.userId,
        phone : response.phoneNo != null ? response.phoneNo : 'N/A',
        role : this.getUserRole(response.userType)
      };

    this.contactFormIndividual.patchValue(values);
  }

  saveOrUpdateNetwork() {
    this.networkDetailForm.markAllAsTouched();
    if (this.networkDetailForm.valid) {

      const params = {
        ...this.networkDetailForm.value,
        businessId: this.businessId
      };
      this.util.startLoader();
      this.API.create('business/createBusinessUsersNetwork', params).subscribe(res => {
        this.util.stopLoader();
        if (res.code === AppSettings.SUCESS_CODE) {
          this.closeModal(true);
        } else if (res.code == "99998") {
          this.networkDetailForm.get('businessNetworkName').setErrors({ exists: true });
          this.errorMsgTxt = "Network already exists";
        }
      });
    }
  }


  loadNetworks() {
    const data = {
      businessId: this.businessId,
      "limit":50,
      ...(this.TYPE !== 'EDIT' ? { status: 'ACTIVE' } : {})
    };
    this.API.create('business/getBusinessUsersNetworkList', data).subscribe(res => {
      this.networks = res.data.businessNetworkList;
      const netWork = this.TYPE === 'EDIT' ? this.DATA.networkName : null;
      if (netWork != null) {
        let data = netWork.split(',');
        let find = [];
        this.networks.forEach((element, i) => {
          data.forEach(s => {
            if(element.businessNetworkName === s){
               find.push(element.businessNetworkId);
            }
          });
        });
        this.contactFormIndividual.get('businessNetworks').patchValue(find);
      }
    });
  }

  capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  closeModal(show: boolean = false) {
    this.submit = false
    this.modalService.hide(this.modalService.getModalsCount());

    if (show) {
      Swal.fire({
        icon: 'success',
        title: `${this.CONTENT === 'contacts' ? 'Contact'
          : this.CONTENT === 'businessNetworks' ? 'Network'
          : this.CONTENT === 'businessContacts' ? 'Contact'
          : this.capitalizeFirstLetter(this.CONTENT)}
          ${this.CONTENT === 'network' || this.CONTENT === 'businessNetworks' ? 'added' : 'requested'} successfully`,

        showConfirmButton: false,
        timer: 2000
      }).then(r => {
        this.customerService.emitRefresh(this.CONTENT);
      });

      this.response.emit({ content: 'SUCESS' });
    }
    else {
      this.response.emit({ content: 'CLOSED' });
    }


    if (this.CONTENT === "businessContacts") {
      this.contactFormBusiness.reset();
      this.enableFieldsBusiness(this.enablekeyBusiness);
    }
    else if (this.CONTENT === "contacts") {
      this.contactFormIndividual.reset();
      this.enableFields(this.enablekeys)
    }
    else if (this.CONTENT === "network") {
      this.networkDetailForm.reset();
    }


  }



}
